<script setup lang="ts">
import { computed, ref } from 'vue';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import type { TooltipFormatter } from 'vue-slider-component/typings/typings';

const props = withDefaults(
    defineProps<{
        value?: number;
        min?: number;
        max?: number;
        disabled?: boolean;
        formatter?: TooltipFormatter;
    }>(),
    { min: 0, max: 100 }
);

const emit = defineEmits<{
    (e: 'input', val: number): void;
}>();

const _value = ref(0);

const model = computed({
    get: () => props.value ?? _value.value,
    set: (val: number) => {
        _value.value = val;
        emit('input', val);
    }
});
</script>

<template>
    <vue-slider
        v-model="model"
        class="c-slider-wrapper"
        drag-on-click
        :min="min"
        :max="max"
        :tooltip-formatter="formatter"
        :disabled="disabled"
        :height="8"
    />
</template>

<style lang="scss" scoped>
.c-slider-wrapper {
    :deep() {
        .vue-slider-rail {
            height: 0.25rem;
        }
    }
}
</style>
